import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyAXoPm6REqCrPKaIzofbVDZ_uT8CXKzShc',
  authDomain: 'amar-app-v2.firebaseapp.com',
  projectId: 'amar-app-v2',
  storageBucket: 'amar-app-v2.firebasestorage.app',
  messagingSenderId: '757002195912',
  appId: '1:757002195912:web:6041f12ccbdade320926fd'
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = initializeFirestore(app, { localCache: persistentLocalCache() });
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-east1');
